module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/health.json
// module id = 385
// module chunks = 54521723183125